import type { ComplexTab } from "@/domains/navigation/components/complex-breadcrumb-dropdown"
import { AddSquareIcon, WithdrawIcon } from "@/domains/icons"
import { StakeSquareIcon } from "@/domains/icons/huge-icons/monotone/square/stake-square"
import { UnstakeSquareIcon } from "@/domains/icons/huge-icons/monotone/square/unstake-square"

export const ENABLE_ZAPS = true

export const CLASSIC_LIQUIDITY_TABS: ComplexTab[] = [
  {
    id: "add-classic-pools",
    label: "Add Liquidity",
    tabLabel: "Add",
    description: "Add liquidity to a pool",
    slug: "/add",
    icon: AddSquareIcon,
  },
  {
    id: "stake-classic-pools",
    label: "Stake Liquidity",
    tabLabel: "Stake",
    description: "Stake liquidity int to a gauge",
    slug: "/stake",
    icon: StakeSquareIcon,
  },
  {
    id: "unstake-classic-pools",
    label: "Unstake Liquidity",
    tabLabel: "Unstake",
    description: "Unstake liquidity from a gauge",
    slug: "/unstake",
    icon: UnstakeSquareIcon,
  },
  {
    id: "withdraw-classic-pools",
    label: "Withdraw Liquidity",
    tabLabel: "Withdraw",
    description: "Withdraw tokens from classic LP",
    slug: "/withdraw",
    icon: WithdrawIcon,
  },
] as const
